<template>
  <div>
    <SelectRoot
      v-model="buildingId"
      @update:modelValue="handleUpdateModelValue"
      required
    >
      <BuildingSelectList :items="filteredBuildings" />
    </SelectRoot>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { storeToRefs } from "pinia";
import { SelectRoot } from "radix-vue";
import { BuildingSelectList } from "@/SharedComponents/Select/Building";
import { useFilters } from "@/Composables/useFilters";
import { useSites } from "@/Composables/useSites";

// Define Emits
const emit = defineEmits(["submit", "update:modelValue"]);

// Define Props
const props = defineProps({
  initialState: { type: String, required: false },
  query: { type: String, required: false },
  buildings: { type: Array, required: false },
});

// Filters: Global
const globalFilterStore = useFilters("global");
const { filterValues } = storeToRefs(globalFilterStore);

// Sites
const { isLoading, data } = useSites();

// Refs
const buildingId = ref(props.initialState || filterValues.value.tenant?.[0]);

// Computed Props
const buildings = computed(() => {
  if (props.buildings) {
    return props.buildings;
  }

  if (isLoading.value) {
    return [];
  }
  return data.value;
});

const filteredBuildings = computed(() => {
  if (!props.query) {
    return buildings.value;
  }
  return buildings.value.filter((building) => {
    return building.name.toLowerCase().includes(props.query);
  });
});

const selectedBuilding = computed(() =>
  buildings.value.find((building) => building.id === buildingId.value)
);

const isDirty = computed(() => {
  return buildingId.value !== props.initialState;
});

// Functions
const submit = () => {
  if (!isDirty.value) {
    return;
  }
  emit("submit", selectedBuilding.value);
};

const handleUpdateModelValue = (value) => {
  emit("update:modelValue", value);
  submit();
};

defineExpose({
  isDirty,
  submit,
});
</script>
